module.exports = __webpack_public_path__ + "static/media/banner-amor-por-pg.dd8cec97.png";